import {agendaDirectory} from "./access/patientDirectory";
import {
  getDeviceTimeZone,
  localizeScheduleEntry
} from "./utils/timezone";
import {auth} from "./firebase";
import {patientDirectory} from "./access/patientDirectory";
import { useEffect, useMemo, useRef, useState } from "react";

import { db } from "./firebase";

import { useClinic }
  from "./context/ClinicContext";

import {
  collection,
  addDoc,
  onSnapshot,
  serverTimestamp,
  doc,
  updateDoc,
} from "./access/firestore";

import PacienteDetalle
  from "./PacienteDetalle";

import {
  usePatient
} from "./PatientContext";

import {
  Users,
  Search,
  UserPlus,
  CalendarDays,
  CircleDollarSign,
  Archive,
  MoreVertical,
  RotateCcw,
  Undo2,
  MessageCircle
} from "lucide-react";

export default function Pacientes({
  onIrACita
}) {

  const { clinicId } =
    useClinic();
  const deviceTimeZone = getDeviceTimeZone();

  const {
    selectedPatient,
    setSelectedPatient
  } = usePatient();

  console.log(
  "SELECTED PATIENT:",
  selectedPatient
);

  const [
    pacientes,
    setPacientes
  ] = useState([]);

  const [
    citas,
    setCitas
  ] = useState([]);

  const [
    cuentasPorCobrar,
    setCuentasPorCobrar
  ] = useState([]);

  const [
    busqueda,
    setBusqueda
  ] = useState("");

  const [
    nombre,
    setNombre
  ] = useState("");

  const [
    apellidos,
    setApellidos
  ] = useState("");

  const [whatsapp, setWhatsapp] = useState("");
  const [whatsappCountryCode, setWhatsappCountryCode] = useState("+52");
  const [mostrarFormularioNuevo, setMostrarFormularioNuevo] = useState(false);
  const [guardandoPaciente, setGuardandoPaciente] = useState(false);
  const [pestanaPacientes, setPestanaPacientes] = useState("activos");
  const [menuPacienteAbierto, setMenuPacienteAbierto] = useState(null);
  const [pacientePorArchivar, setPacientePorArchivar] = useState(null);
  const [archivadoPendiente, setArchivadoPendiente] = useState(null);
  const [segundosDeshacer, setSegundosDeshacer] = useState(3);
  const [procesandoArchivado, setProcesandoArchivado] = useState(false);
  const temporizadorArchivado = useRef(null);
  const temporizadorCuentaRegresiva = useRef(null);

  useEffect(() => {
    if (menuPacienteAbierto === null) return;

    const cerrarMenuAlHacerClickFuera = (e) => {
      if (!e.target.closest("[data-menu-paciente]")) {
        setMenuPacienteAbierto(null);
      }
    };

    document.addEventListener(
      "pointerdown",
      cerrarMenuAlHacerClickFuera
    );

    return () => {
      document.removeEventListener(
        "pointerdown",
        cerrarMenuAlHacerClickFuera
      );
    };
  }, [menuPacienteAbierto]);

  // =========================
  // CARGAR PACIENTES
  // =========================

  useEffect(() => {

    if (!clinicId) return;

    const unsubscribePacientes =
      onSnapshot(

        patientDirectory(db,clinicId),

        snap => {

          setPacientes(

            snap.docs.map(doc => localizeScheduleEntry({

              id: doc.id,

              ...doc.data()

            }, deviceTimeZone))

          );

        }

      );

    const unsubscribeCitas =
      onSnapshot(

        agendaDirectory(db,clinicId),

        snap => {

          setCitas(

            snap.docs.map(doc => localizeScheduleEntry({

              id: doc.id,

              ...doc.data()

            }, deviceTimeZone))

          );

        }

      );

    return () => {

      unsubscribePacientes();

      unsubscribeCitas();

    };

  }, [clinicId, deviceTimeZone]);

    useEffect(() => {

      if (!clinicId) return;

      const unsubscribes = [];

      pacientes.forEach(paciente => {

          const cuentasRef = collection(

              db,

              "clinics",

              clinicId,

              "pacientes",

              paciente.id,

              "cuentasPorCobrar"

          );

          const unsubscribe = onSnapshot(

              cuentasRef,

              snap => {

                  const nuevasCuentas =
                      snap.docs.map(docSnap => ({

                          id:
                              docSnap.id,

                          pacienteId:
                              paciente.id,

                          ...docSnap.data()

                      }));

                  setCuentasPorCobrar(prev => {

                      // Elimina TODAS las cuentas anteriores
                      // de este paciente del estado local.

                      const otrasCuentas =
                          prev.filter(

                              cuenta =>
                                  cuenta.pacienteId !==
                                  paciente.id

                          );

                      // Agrega únicamente las cuentas
                      // que existen actualmente en Firestore.

                      return [

                          ...otrasCuentas,

                          ...nuevasCuentas

                      ];

                  });

              },

              error => {

                  console.error(

                      "Error escuchando cuentas por cobrar:",

                      paciente.id,

                      error

                  );

              }

          );

          unsubscribes.push(
              unsubscribe
          );

      });

      return () => {

          unsubscribes.forEach(
              unsubscribe =>
                  unsubscribe()
          );

      };

  }, [

      clinicId,

      pacientes

  ]);

  // =========================
  // SINCRONIZAR PACIENTE SELECCIONADO
  // =========================

  useEffect(() => {

      if (!selectedPatient?.id) return;

      const pacienteActualizado = pacientes.find(

          p => p.id === selectedPatient.id

      );

      if (!pacienteActualizado) return;

      if (
          JSON.stringify(pacienteActualizado) !==
          JSON.stringify(selectedPatient)
      ) {

          setSelectedPatient(
              pacienteActualizado
          );

      }

  }, [

      pacientes,
      selectedPatient,
      setSelectedPatient

  ]);

  // =========================
  // GUARDAR
  // =========================
  
  const getWhatsAppPrefix = (countryCode) => {
    switch (countryCode) {
      case "+52": return "521";
      case "+1": return "1";
      case "+57": return "57";
      case "+54": return "54";
      case "+56": return "56";
      case "+51": return "51";
      case "+34": return "34";
      default: return (countryCode || "").replace("+", "");
    }
  };

  const guardar = async (e) => {
    e?.preventDefault();

    if (guardandoPaciente) return;

    if (!clinicId) {
      alert("No se encontró la clínica");
      return;
    }

    const nombreLimpio = nombre.trim();
    const apellidosLimpios = apellidos.trim();
    const whatsappLimpio = whatsapp.trim();
    const whatsappNormalizado =
      `${getWhatsAppPrefix(whatsappCountryCode)}${whatsappLimpio.replace(/\D/g, "")}`;

    if (!nombreLimpio || !apellidosLimpios || !whatsappLimpio) {
      alert("Completa nombres, apellidos y WhatsApp.");
      return;
    }

    setGuardandoPaciente(true);

    try {
      await addDoc(
        collection(db, "clinics", clinicId, "pacientes"),
        {
          nombre: nombreLimpio,
          apellidos: apellidosLimpios,
          whatsapp: whatsappNormalizado,
          whatsappCountryCode,
          telefono: "",
          correo: "",
          rfc: "",
          fechaNacimiento: "",
          calle: "",
          numeroExterior: "",
          numeroInterior: "",
          cp: "",
          colonia: "",
          ciudad: "",
          estado: "",
          pais: "",
          alergias: "",
          antecedentesMedicos: "",
          medicamentos: "",
          createdAt: serverTimestamp(),
          createdBy: auth.currentUser?.uid || "",
        }
      );

      setNombre("");
      setApellidos("");
      setWhatsapp("");
      setWhatsappCountryCode("+52");
      setMostrarFormularioNuevo(false);
    } catch (err) {
      console.error("Error creando paciente:", err);
      alert("No se pudo crear el paciente. Intenta nuevamente.");
    } finally {
      setGuardandoPaciente(false);
    }
  };

  // =========================
  // PACIENTES ENRIQUECIDOS
  // =========================

  const pacientesConInfo = useMemo(() => {
    const ahora = new Date();
    const citasPorPaciente = new Map();
    const saldoPorPaciente = new Map();

    citas.forEach((cita) => {
      if (cita.pacienteId) {
        const actuales = citasPorPaciente.get(cita.pacienteId) || [];
        actuales.push(cita);
        citasPorPaciente.set(cita.pacienteId, actuales);
      }
    });

    cuentasPorCobrar.forEach((cuenta) => {
      if (cuenta.pacienteId) {
        saldoPorPaciente.set(
          cuenta.pacienteId,
          (saldoPorPaciente.get(cuenta.pacienteId) || 0) + Number(cuenta.saldo || 0)
        );
      }
    });

    return pacientes.map((p) => {
      const siguienteCita = (citasPorPaciente.get(p.id) || [])
        .filter((cita) => {
          if (cita.estado !== "activa" || !cita.fecha) return false;
          return new Date(`${cita.fecha}T${cita.hora || "00:00"}`) >= ahora;
        })
        .sort((a, b) => (
          new Date(`${a.fecha}T${a.hora || "00:00"}`) -
          new Date(`${b.fecha}T${b.hora || "00:00"}`)
        ))[0] || null;

      return {
        ...p,
        saldoPendiente: saldoPorPaciente.get(p.id) || 0,
        siguienteCita,
      };
    });
  }, [pacientes, citas, cuentasPorCobrar]);

  const estadisticasPacientes = useMemo(() => ({
    activos: pacientes.filter((p) => p.archivado !== true).length,
    archivados: pacientes.filter((p) => p.archivado === true).length,
    conCita: pacientesConInfo.filter((p) => p.archivado !== true && p.siguienteCita).length,
    conSaldo: pacientesConInfo.filter((p) => p.archivado !== true && p.saldoPendiente > 0).length,
  }), [pacientes, pacientesConInfo]);

    // =========================
    // FORMATEAR WHATSAPP
    // =========================

    const formatearWhatsApp = (numero) => {

      if (!numero) return "Sin WhatsApp";

      let limpio = String(numero).replace(/\D/g, "");

      if (limpio.startsWith("521")) {

        limpio = limpio.substring(3);

      } else if (limpio.startsWith("52")) {

        limpio = limpio.substring(2);

      }

      if (limpio.length === 10) {

        return `${limpio.substring(0,3)} ${limpio.substring(3,6)} ${limpio.substring(6)}`;

      }

      return limpio;

    };

    // =========================
    // FORMATEAR PRÓXIMA CITA
    // =========================

    const formatearProximaCita = (cita) => {

      if (!cita) return "Sin Cita Programada";

      const fechaCita = new Date(`${cita.fecha}T${cita.hora}`);

      const hoy = new Date();

      const inicioHoy = new Date(
        hoy.getFullYear(),
        hoy.getMonth(),
        hoy.getDate()
      );

      const inicioCita = new Date(
        fechaCita.getFullYear(),
        fechaCita.getMonth(),
        fechaCita.getDate()
      );

      const diferenciaDias = Math.round(

        (inicioCita - inicioHoy) /

        (1000 * 60 * 60 * 24)

      );

      const hora = fechaCita.toLocaleTimeString(

        "es-MX",

        {

          hour: "numeric",

          minute: "2-digit",

          hour12: true

        }

      );

      if (diferenciaDias === 0) {

        return `Hoy · ${hora}`;

      }

      if (diferenciaDias === 1) {

        return `Mañana · ${hora}`;

      }

      const dias = [

        "Dom",

        "Lun",

        "Mar",

        "Mié",

        "Jue",

        "Vie",

        "Sáb"

      ];

      const meses = [

        "Ene",

        "Feb",

        "Mar",

        "Abr",

        "May",

        "Jun",

        "Jul",

        "Ago",

        "Sep",

        "Oct",

        "Nov",

        "Dic"

      ];

      return `${dias[fechaCita.getDay()]} ${fechaCita.getDate()} ${meses[fechaCita.getMonth()]} · ${hora}`;

    };

  
  // =========================
  // ARCHIVAR Y RESTAURAR
  // =========================

  const cancelarTemporizadoresArchivado = () => {
    if (temporizadorArchivado.current) {
      clearTimeout(temporizadorArchivado.current);
      temporizadorArchivado.current = null;
    }

    if (temporizadorCuentaRegresiva.current) {
      clearInterval(temporizadorCuentaRegresiva.current);
      temporizadorCuentaRegresiva.current = null;
    }
  };

  useEffect(() => {
    return () => {
      cancelarTemporizadoresArchivado();
    };
  }, []);

  const iniciarArchivado = () => {
    if (!pacientePorArchivar || !clinicId) return;

    const paciente = pacientePorArchivar;

    setPacientePorArchivar(null);
    setArchivadoPendiente(paciente);
    setSegundosDeshacer(3);
    setMenuPacienteAbierto(null);

    const inicio = Date.now();

    temporizadorCuentaRegresiva.current = setInterval(() => {
      const transcurrido = Date.now() - inicio;
      const restantes = Math.max(0, 3 - Math.ceil(transcurrido / 1000));
      setSegundosDeshacer(restantes);
    }, 100);

    temporizadorArchivado.current = setTimeout(async () => {
      try {
        setProcesandoArchivado(true);

        await updateDoc(
          doc(db, "clinics", clinicId, "pacientes", paciente.id),
          {
            archivado: true,
            archivadoAt: serverTimestamp(),
          }
        );

        setArchivadoPendiente(null);
      } catch (error) {
        console.error("Error archivando paciente:", error);
        setArchivadoPendiente(null);
        alert("No se pudo archivar al paciente. Intenta nuevamente.");
      } finally {
        cancelarTemporizadoresArchivado();
        setProcesandoArchivado(false);
      }
    }, 3000);
  };

  const deshacerArchivado = () => {
    if (!archivadoPendiente || procesandoArchivado) return;

    cancelarTemporizadoresArchivado();
    setArchivadoPendiente(null);
    setSegundosDeshacer(3);
  };

  const restaurarPaciente = async (paciente) => {
    if (!clinicId) return;

    try {
      await updateDoc(
        doc(db, "clinics", clinicId, "pacientes", paciente.id),
        {
          archivado: false,
          archivadoAt: null,
        }
      );

      setMenuPacienteAbierto(null);
    } catch (error) {
      console.error("Error restaurando paciente:", error);
      alert("No se pudo restaurar al paciente. Intenta nuevamente.");
    }
  };

  // =========================
  // FILTRO
  // =========================

  const pacientesFiltrados = pacientesConInfo.filter((p) => {
    const estaArchivado = p.archivado === true;

    if (pestanaPacientes === "activos" && estaArchivado) return false;
    if (pestanaPacientes === "archivados" && !estaArchivado) return false;

    const texto = busqueda.trim().toLowerCase();
    const nombreCompleto = `${p.nombre || ""} ${p.apellidos || ""}`;
    const numeroWhatsApp = p.whatsapp || "";

    return `${nombreCompleto} ${numeroWhatsApp}`
      .toLowerCase()
      .includes(texto);
  });

  // =========================
  // DETALLE
  // =========================

  if (selectedPatient) {

    return (

      <div style={{
        width:"100%"
      }}>

        <PacienteDetalle
          paciente={
            selectedPatient
          }
          onBack={() =>
            setSelectedPatient(null)
          }
          onIrACita={onIrACita}
        />

      </div>
    );
  }

  // =========================
  // RENDER
  // =========================

  
  return (
    <div
      className="vd-module-page vd-patients-page"
      style={{
        padding: 24,
        minHeight: "100%",
        background: "#f4f7fc",
        color: "#172033",
      }}
    >
      {/* ENCABEZADO */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 16,
          marginBottom: 22,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#dbeafe",
              color: "#2563eb",
              flexShrink: 0,
            }}
          >
            <Users size={27} />
          </div>

          <div>
            <h2
              style={{
                margin: 0,
                fontSize: 27,
                fontWeight: 750,
                letterSpacing: "-0.6px",
              }}
            >
              Pacientes
            </h2>

            <p
              style={{
                margin: "5px 0 0",
                color: "#71809a",
                fontSize: 13,
              }}
            >
              Administra y consulta los expedientes clínicos.
            </p>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "11px 14px",
              border: "1px solid #e5edf7",
              borderRadius: 13,
              background: "#fff",
              color: "#64748b",
              fontSize: 13,
              fontWeight: 650,
            }}
          >
            <Users size={17} color="#2563eb" />
            {pacientes.length} pacientes
          </div>

          <button
            type="button"
            onClick={() => setMostrarFormularioNuevo(true)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 9,
              padding: "13px 18px",
              border: "none",
              borderRadius: 13,
              background: "linear-gradient(135deg, #3474f6, #2455df)",
              color: "#fff",
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 700,
              boxShadow: "0 6px 16px rgba(37,99,235,.20)",
            }}
          >
            <UserPlus size={18} />
            Nuevo paciente
          </button>
        </div>
      </div>

      <div
        className="vd-patients-summary"
        aria-label="Resumen de pacientes"
      >
        {[
          { label: "Activos", value: estadisticasPacientes.activos, tone: "blue", icon: Users },
          { label: "Con próxima cita", value: estadisticasPacientes.conCita, tone: "teal", icon: CalendarDays },
          { label: "Con saldo pendiente", value: estadisticasPacientes.conSaldo, tone: "amber", icon: CircleDollarSign },
        ].map(({ label, value, tone, icon: Icon }) => (
          <div key={label} className={`vd-patient-stat vd-patient-stat-${tone}`}>
            <span className="vd-patient-stat-icon"><Icon size={17} /></span>
            <span>
              <strong>{value}</strong>
              <small>{label}</small>
            </span>
          </div>
        ))}
      </div>

      {/* BUSCADOR */}

      <div style={{ position: "relative", marginBottom: 17 }}>
        <Search
          size={19}
          color="#94a3b8"
          style={{
            position: "absolute",
            left: 17,
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
          }}
        />

        <input
          type="search"
          placeholder="Buscar por nombre, apellidos o WhatsApp..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          style={{
            boxSizing: "border-box",
            width: "100%",
            padding: "15px 17px 15px 48px",
            borderRadius: 15,
            border: "1px solid #e5edf7",
            background: "#fff",
            color: "#172033",
            fontSize: 14,
            outlineColor: "#2563eb",
            boxShadow: "0 3px 12px rgba(31,51,86,.035)",
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: 8,
          padding: 5,
          marginBottom: 16,
          width: "fit-content",
          maxWidth: "100%",
          border: "1px solid #e5edf7",
          borderRadius: 13,
          background: "#eaf0f8",
        }}
      >
        {[
          {
            id: "activos",
            label: "Activos",
            icon: Users,
            cantidad: pacientes.filter((p) => p.archivado !== true).length,
          },
          {
            id: "archivados",
            label: "Archivados",
            icon: Archive,
            cantidad: pacientes.filter((p) => p.archivado === true).length,
          },
        ].map((tab) => {
          const IconoTab = tab.icon;
          const seleccionado = pestanaPacientes === tab.id;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => {
                setPestanaPacientes(tab.id);
                setBusqueda("");
                setMenuPacienteAbierto(null);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "10px 15px",
                border: "none",
                borderRadius: 10,
                background: seleccionado ? "#ffffff" : "transparent",
                color: seleccionado ? "#2563eb" : "#64748b",
                fontSize: 13,
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: seleccionado
                  ? "0 2px 7px rgba(31,51,86,.07)"
                  : "none",
              }}
            >
              <IconoTab size={16} />
              {tab.label}
              <span
                style={{
                  padding: "2px 7px",
                  borderRadius: 7,
                  background: seleccionado ? "#dbeafe" : "#e2e8f0",
                  fontSize: 11,
                }}
              >
                {tab.cantidad}
              </span>
            </button>
          );
        })}
      </div>

      <div
        style={{
          marginBottom: 16,
          color: "#71809a",
          fontSize: 12,
        }}
      >
        {busqueda.trim()
          ? `${pacientesFiltrados.length} resultados encontrados`
          : `${pacientes.length} pacientes registrados`}
      </div>

      {/* TARJETAS DE PACIENTES */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(265px, 1fr))",
          gap: 12,
          alignItems: "start",
        }}
      >
        {pacientesFiltrados.map((p) => (
            <div
            key={p.id}
              className="vd-patient-card"
              role="button"
              tabIndex={0}
              aria-label={`Abrir expediente de ${p.nombre || "paciente"} ${p.apellidos || ""}`}
            onClick={() => setSelectedPatient(p)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setSelectedPatient(p);
                }
              }}
            style={{
              border: "1px solid #e5edf7",
              borderRadius: 17,
              padding: "15px 16px",
              background: "#ffffff",
              boxShadow: "0 3px 12px rgba(31, 51, 86, 0.045)",
              cursor: "pointer",
              transition: "transform 0.18s ease, box-shadow 0.18s ease",
              minWidth: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 8px 20px rgba(37, 99, 235, 0.09)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 3px 12px rgba(31, 51, 86, 0.045)";
            }}
          >
            {/* NOMBRE DEL PACIENTE */}

            <div
              className="vd-patient-card-heading"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 11,
                minWidth: 0,
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  flexShrink: 0,
                  borderRadius: 12,
                  background: "linear-gradient(135deg, #dbeafe, #eff6ff)",
                  color: "#2563eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: 750,
                }}
              >
                {(
                  `${p.nombre || ""} ${p.apellidos || ""}`
                    .trim()
                    .split(/\s+/)[0]?.[0] || "P"
                ).toUpperCase()}
                {(
                  `${p.nombre || ""} ${p.apellidos || ""}`
                    .trim()
                    .split(/\s+/)
                    .slice(-1)[0]?.[0] || ""
                ).toUpperCase()}
              </div>

              <div
                style={{
                  flex: 1,
                  minWidth: 0,
                  fontSize: 15,
                  fontWeight: 750,
                  color: "#172033",
                  lineHeight: 1.35,
                  overflowWrap: "anywhere",
                }}
              >
                {p.nombre} {p.apellidos}
              </div>
              
                {pestanaPacientes === "activos" ? (
                  <div style={{ position: "relative", flexShrink: 0 }}>
                    <button
                      type="button"
                      aria-label={`Acciones de ${p.nombre || "paciente"}`}
                      data-menu-paciente="true"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuPacienteAbierto(
                          menuPacienteAbierto === p.id ? null : p.id
                        );
                      }}
                      style={{
                        width: 32,
                        height: 32,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #e5edf7",
                        borderRadius: 10,
                        background: "#ffffff",
                        color: "#64748b",
                        cursor: "pointer",
                      }}
                    >
                      <MoreVertical size={18} />
                    </button>

                    {menuPacienteAbierto === p.id && (
                      <div
                        data-menu-paciente="true"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          position: "absolute",
                          zIndex: 100,
                          top: 36,
                          right: 0,
                          width: 190,
                          padding: 5,
                          border: "1px solid #e5edf7",
                          borderRadius: 13,
                          background: "#ffffff",
                          boxShadow: "0 12px 30px rgba(15,23,42,.15)",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => {
                            setMenuPacienteAbierto(null);
                            setSelectedPatient(p);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 9,
                            width: "100%",
                            padding: "11px 10px",
                            border: "none",
                            borderRadius: 8,
                            background: "#ffffff",
                            color: "#334155",
                            textAlign: "left",
                            cursor: "pointer",
                            fontSize: 12,
                          }}
                        >
                          <Users size={15} />
                          Ver expediente
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setMenuPacienteAbierto(null);
                            setPacientePorArchivar(p);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 9,
                            width: "100%",
                            padding: "11px 10px",
                            border: "none",
                            borderRadius: 8,
                            background: "#ffffff",
                            color: "#dc2626",
                            textAlign: "left",
                            cursor: "pointer",
                            fontSize: 12,
                            fontWeight: 650,
                          }}
                        >
                          <Archive size={15} />
                          Archivar paciente
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <button
                    type="button"
                    title="Restaurar paciente"
                    onClick={(e) => {
                      e.stopPropagation();
                      restaurarPaciente(p);
                    }}
                    style={{
                      width: 34,
                      height: 34,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #dbeafe",
                      borderRadius: 10,
                      background: "#eff6ff",
                      color: "#2563eb",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  >
                    <RotateCcw size={16} />
                  </button>
                )}
            </div>

            {/* WHATSAPP */}

            <div
              className="vd-patient-card-row"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
                padding: "9px 10px",
                borderRadius: 11,
                background: "#f7f9fc",
                marginTop: 7,
                minWidth: 0,
              }}
            >
              <MessageCircle
                size={16}
                color="#16a34a"
                style={{ flexShrink: 0 }}
              />

              <span
                style={{
                  fontSize: 12,
                  color: "#475569",
                  overflowWrap: "anywhere",
                }}
              >
                {formatearWhatsApp(p.whatsapp)}
              </span>
            </div>

            {/* SALDO PENDIENTE */}

            <div
              className={`vd-patient-card-row ${p.saldoPendiente > 0 ? "vd-patient-card-row-alert" : "vd-patient-card-row-success"}`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
                padding: "9px 10px",
                borderRadius: 11,
                background: "#f7f9fc",
                marginTop: 7,
                minWidth: 0,
              }}
            >
              <CircleDollarSign
                size={16}
                color="#2563eb"
                style={{ flexShrink: 0 }}
              />

              <span
                style={{
                  fontSize: 12,
                  fontWeight: 650,
                  color: p.saldoPendiente > 0 ? "#dc2626" : "#16a34a",
                  overflowWrap: "anywhere",
                }}
              >
                {p.saldoPendiente > 0
                  ? `$${p.saldoPendiente.toLocaleString("es-MX")}`
                  : "Sin saldo pendiente"}
              </span>
            </div>

            {/* PRÓXIMA CITA */}

            <div
              className="vd-patient-card-row"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
                padding: "9px 10px",
                borderRadius: 11,
                background: "#f7f9fc",
                marginTop: 7,
                minWidth: 0,
              }}
            >
              <CalendarDays
                size={15}
                color="#64748b"
                style={{ flexShrink: 0 }}
              />

              <span
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#334155",
                  lineHeight: 1.4,
                  overflowWrap: "anywhere",
                }}
              >
                {formatearProximaCita(p.siguienteCita)}
              </span>
            </div>
          </div>
        ))}
      </div>

        {pacientePorArchivar && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 10000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20,
              background: "rgba(15,23,42,.5)",
              backdropFilter: "blur(4px)",
            }}
          >
            <div
              role="alertdialog"
              aria-modal="true"
              aria-labelledby="titulo-confirmar-archivo"
              style={{
                width: "100%",
                maxWidth: 430,
                padding: 26,
                borderRadius: 22,
                background: "#ffffff",
                boxShadow: "0 24px 70px rgba(15,23,42,.24)",
              }}
            >
              <div
                style={{
                  width: 48,
                  height: 48,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 15,
                  background: "#fef2f2",
                  color: "#dc2626",
                  marginBottom: 18,
                }}
              >
                <Archive size={24} />
              </div>

              <h2
                id="titulo-confirmar-archivo"
                style={{
                  margin: "0 0 10px",
                  color: "#172033",
                  fontSize: 21,
                  fontWeight: 750,
                }}
              >
                ¿Archivar paciente?
              </h2>

              <p style={{ margin: "0 0 12px", color: "#475569", fontSize: 14, lineHeight: 1.7 }}>
                Vas a archivar a{" "}
                <strong>
                  {pacientePorArchivar.nombre} {pacientePorArchivar.apellidos}
                </strong>.
              </p>

              <p style={{ margin: "0 0 22px", color: "#64748b", fontSize: 12, lineHeight: 1.7 }}>
                El paciente dejará de aparecer en la lista de activos. Su expediente,
                citas y pagos se conservarán. Podrás restaurarlo desde «Archivados».
                Esta acción no elimina sus datos.
              </p>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <button
                  type="button"
                  onClick={() => setPacientePorArchivar(null)}
                  style={{
                    padding: "12px 16px",
                    border: "1px solid #dbe4f0",
                    borderRadius: 11,
                    background: "#ffffff",
                    color: "#475569",
                    fontWeight: 650,
                    cursor: "pointer",
                  }}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  onClick={iniciarArchivado}
                  style={{
                    padding: "12px 16px",
                    border: "none",
                    borderRadius: 11,
                    background: "#dc2626",
                    color: "#ffffff",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  Sí, archivar
                </button>
              </div>
            </div>
          </div>
        )}

        {archivadoPendiente && (
          <div
            role="status"
            style={{
              position: "fixed",
              zIndex: 11000,
              left: "50%",
              bottom: 28,
              transform: "translateX(-50%)",
              width: "min(520px, calc(100% - 32px))",
              overflow: "hidden",
              border: "1px solid #334155",
              borderRadius: 16,
              background: "#172033",
              color: "#ffffff",
              boxShadow: "0 14px 40px rgba(15,23,42,.28)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "15px 16px",
              }}
            >
              <Archive size={20} color="#93c5fd" />

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700 }}>
                  Paciente archivado
                </div>
                <div style={{ marginTop: 4, color: "#cbd5e1", fontSize: 11 }}>
                  {archivadoPendiente.nombre} {archivadoPendiente.apellidos}
                </div>
              </div>

              <button
                type="button"
                disabled={procesandoArchivado}
                onClick={deshacerArchivado}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "9px 11px",
                  border: "1px solid #64748b",
                  borderRadius: 10,
                  background: "#26364f",
                  color: "#ffffff",
                  fontSize: 12,
                  fontWeight: 700,
                  cursor: "pointer",
                  flexShrink: 0,
                }}
              >
                <Undo2 size={15} />
                Deshacer
              </button>

              <span style={{ minWidth: 16, color: "#bfdbfe", fontSize: 12 }}>
                {segundosDeshacer}s
              </span>
            </div>

            <div style={{ height: 4, background: "#334155" }}>
              <div
                style={{
                  height: "100%",
                  width: `${(segundosDeshacer / 3) * 100}%`,
                  background: "#60a5fa",
                  transition: "width .1s linear",
                }}
              />
            </div>
          </div>
        )}

      {/* MODAL: NUEVO PACIENTE */}

      {mostrarFormularioNuevo && (
        <div
          onMouseDown={(e) => {
            if (
              e.target === e.currentTarget &&
              !guardandoPaciente
            ) {
              setMostrarFormularioNuevo(false);
            }
          }}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            background: "rgba(15,23,42,.48)",
            backdropFilter: "blur(4px)",
          }}
        >
          <form
            onSubmit={guardar}
            style={{
              width: "100%",
              maxWidth: 470,
              maxHeight: "90vh",
              overflowY: "auto",
              padding: 28,
              borderRadius: 23,
              background: "#fff",
              boxShadow: "0 24px 70px rgba(15,23,42,.22)",
              color: "#172033",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 14,
                marginBottom: 24,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 13 }}>
                <div
                  style={{
                    width: 47,
                    height: 47,
                    borderRadius: 14,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#dbeafe",
                    color: "#2563eb",
                  }}
                >
                  <UserPlus size={23} />
                </div>

                <div>
                  <h2 style={{ margin: 0, fontSize: 21, fontWeight: 750 }}>
                    Nuevo paciente
                  </h2>
                  <p
                    style={{
                      margin: "5px 0 0",
                      color: "#71809a",
                      fontSize: 12,
                    }}
                  >
                    Ingresa los datos básicos del paciente.
                  </p>
                </div>
              </div>

              <button
                type="button"
                aria-label="Cerrar formulario"
                disabled={guardandoPaciente}
                onClick={() => setMostrarFormularioNuevo(false)}
                style={{
                  width: 36,
                  height: 36,
                  flexShrink: 0,
                  border: "1px solid #e5edf7",
                  borderRadius: 11,
                  background: "#fff",
                  color: "#64748b",
                  cursor: "pointer",
                  fontSize: 22,
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: 17 }}>
              <label
                htmlFor="nuevo-paciente-nombres"
                style={{
                  display: "block",
                  marginBottom: 7,
                  fontSize: 13,
                  fontWeight: 650,
                  color: "#334155",
                }}
              >
                Nombres *
              </label>

              <input
                id="nuevo-paciente-nombres"
                autoFocus
                autoComplete="given-name"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre(s) del paciente"
                required
                disabled={guardandoPaciente}
                style={{
                  boxSizing: "border-box",
                  width: "100%",
                  padding: "13px 14px",
                  border: "1px solid #dbe4f0",
                  borderRadius: 12,
                  fontSize: 14,
                }}
              />
            </div>

            <div style={{ marginBottom: 17 }}>
              <label
                htmlFor="nuevo-paciente-apellidos"
                style={{
                  display: "block",
                  marginBottom: 7,
                  fontSize: 13,
                  fontWeight: 650,
                  color: "#334155",
                }}
              >
                Apellidos *
              </label>

              <input
                id="nuevo-paciente-apellidos"
                autoComplete="family-name"
                value={apellidos}
                onChange={(e) => setApellidos(e.target.value)}
                placeholder="Apellido(s) del paciente"
                required
                disabled={guardandoPaciente}
                style={{
                  boxSizing: "border-box",
                  width: "100%",
                  padding: "13px 14px",
                  border: "1px solid #dbe4f0",
                  borderRadius: 12,
                  fontSize: 14,
                }}
              />
            </div>
            
            <div style={{ marginBottom: 22 }}>
              <label
                htmlFor="nuevo-paciente-whatsapp"
                style={{
                  display: "block",
                  marginBottom: 7,
                  fontSize: 13,
                  fontWeight: 650,
                  color: "#334155",
                }}
              >
                WhatsApp *
              </label>

              <div
                style={{
                  display: "grid",                  
                  gridTemplateColumns: "minmax(0, 1.15fr) 68px minmax(0, 1.35fr)",
                  gap: 8,
                  alignItems: "stretch",
                }}
              >
                <select
                  value={whatsappCountryCode}
                  onChange={(e) => setWhatsappCountryCode(e.target.value)}
                  disabled={guardandoPaciente}                
                  style={{
                    boxSizing: "border-box",
                    width: "100%",
                    minWidth: 0,
                    height: 52,
                    padding: "0 12px",
                    border: "1px solid #d7e2f2",
                    borderRadius: 15,
                    fontSize: 13,
                    fontWeight: 500,
                    fontFamily: "inherit",
                    backgroundColor: "#ffffff",
                    color: "#263449",
                    outline: "none",
                    cursor: "pointer",
                    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  }}
                >
                  <option value="+52">🇲🇽 México (+52)</option>
                  <option value="+1">🇺🇸 Estados Unidos (+1)</option>
                  <option value="+1">🇨🇦 Canadá (+1)</option>
                  <option value="+57">🇨🇴 Colombia (+57)</option>
                  <option value="+54">🇦🇷 Argentina (+54)</option>
                  <option value="+56">🇨🇱 Chile (+56)</option>
                  <option value="+51">🇵🇪 Perú (+51)</option>
                  <option value="+34">🇪🇸 España (+34)</option>
                </select>

                <input
                  value={getWhatsAppPrefix(whatsappCountryCode)}
                  readOnly
                  aria-label="Prefijo internacional"                  
                  style={{
                    boxSizing: "border-box",
                    width: "100%",
                    minWidth: 0,
                    height: 52,
                    padding: "0 5px",
                    border: "1px solid #e0e7f1",
                    borderRadius: 15,
                    fontSize: 14,
                    fontFamily: "inherit",
                    textAlign: "center",
                    backgroundColor: "#f5f7fb",
                    color: "#475569",
                    fontWeight: 700,
                    cursor: "default",
                  }}
                />

                <input
                  id="nuevo-paciente-whatsapp"
                  type="tel"
                  inputMode="tel"
                  autoComplete="tel-national"
                  value={whatsapp}
                  onChange={(e) =>
                    setWhatsapp(e.target.value.replace(/\D/g, ""))
                  }
                  placeholder="Número"
                  required
                  disabled={guardandoPaciente}                  
                  style={{
                    boxSizing: "border-box",
                    width: "100%",
                    minWidth: 0,
                    height: 52,
                    padding: "0 13px",
                    border: "1px solid #d7e2f2",
                    borderRadius: 15,
                    fontSize: 14,
                    fontFamily: "inherit",
                    color: "#263449",
                    backgroundColor: "#ffffff",
                    outline: "none",
                    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  }}
                />
              </div>

              <p
                style={{
                  margin: "7px 0 0",
                  color: "#71809a",
                  fontSize: 11,
                }}
              >
                Este número se utilizará para contactar al paciente por WhatsApp.
              </p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap",
                borderTop: "1px solid #edf1f7",
                paddingTop: 19,
              }}
            >
              <button
                type="button"
                disabled={guardandoPaciente}
                onClick={() => setMostrarFormularioNuevo(false)}
                style={{
                  padding: "12px 17px",
                  border: "1px solid #dbe4f0",
                  borderRadius: 12,
                  background: "#fff",
                  color: "#475569",
                  fontSize: 13,
                  fontWeight: 650,
                  cursor: "pointer",
                }}
              >
                Cancelar
              </button>

              <button
                type="submit"
                disabled={guardandoPaciente}
                style={{
                  padding: "12px 19px",
                  border: "none",
                  borderRadius: 12,
                  background: guardandoPaciente ? "#94a3b8" : "#2563eb",
                  color: "#fff",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: guardandoPaciente ? "wait" : "pointer",
                }}
              >
                {guardandoPaciente ? "Guardando..." : "Crear paciente"}
              </button>
            </div>
          </form>
        </div>
      )}

    </div>
  );
}
